// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__FALHH","savePackageButton":"ClientWallet_savePackageButton__2T1Fe"};